import request from "../../untils/request.js"


export const getFeelist = (id) => {
    return request.get(`/outpatient/feelist/${id}`)
}

export const getChargelist = (params) => {
    return request.get('/outpatient/doctoradvice/chargelist',{params})
}


export const doctorAdviceStatistics = (params) => {
    return request.get('/outpatient/api/v2/outpatient/orders/statistics',{params})
}
export const clinicRevenueOverview = (params) => {
    return request.get('/outpatient/api/v2/clinic/operating-report/overview',{params})
}


export const getWestDetail = (id) => {
    return request.get(`/outpatient/rxmain/${id}`)
}

export const getChinaDetail = (params) => {
    return request.get('/outpatient/tcmrxmain/get',{params})
}

export const getOnCreditList = (params) => {
    return request.get('/outpatient/bebttype/list',{params})
}

export const addOnCredit = (data) => {
    return request.post('/outpatient/bebttype',data)
}

export const editOnCredit = (data) => {
    return request.put('/outpatient/bebttype',data)
}

export const getOnCreditById = (params) => {
    return request.get('/outpatient/bebttype/get',{params})
}

export const addConfirmPayment = (data) => {
    return request.post('/outpatient/feelist',data)
}

export const sqbPayment = (params) => {
    return request.get('/outpatient/sqb/pay',{params})
}

export const getSqbPaymentState = (params) => {
    return request.get('/outpatient/sqb/query',{params})
}

export const addYbOutpatientSettleAccounts = (data) => {
    return request.post('/outpatient/feesettlement',data)
}

export const updateYbOutpatientSettleAccounts = (data) => {
    return request.put('/outpatient/feesettlement',data)
}

export const getYbOutpatientSettleAccounts = (params) => {
    return request.get('/outpatient/feesettlement/get',{params})
}

export const getFeeList = (params) => {
    return request.get('/outpatient/feelist/list',{params})
}

export const getRegisterList= (params) => {
    return request.get('/outpatient/register/list',{params})
}

export const getLastSettleAccountsTime= () => {
    return request.get('/outpatient/shhar/lastOne')
}

export const addSettleAccounts= (data) => {
    return request.post('/outpatient/shhar',data)
}

export default{

}